import { useMutation } from 'react-query';
import { MutationConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const mapFileUploadCheckToApiDto = (data: IBillingUploadForm): IBillingUploadDelete => {
  return {
    month: +data.month,
    providerID: +data.providerID,
    year: +data.year
  }
}

const bulkDeleteFile = ( {data} : {data: IBillingUploadForm}): Promise<string> => {
  const mapedData = mapFileUploadCheckToApiDto(data);
  return axiosDefaultApi.post(`/api/Billing/BulkDelete`, mapedData);
};

type QueryFnType = typeof bulkDeleteFile;

type UseBulkDeleteFileOptions = {
  data: IBillingUploadForm;
  config?: MutationConfig<QueryFnType>;
};

export const useBulkDeleteFile = ({ config }: UseBulkDeleteFileOptions) => {
    const {addNotification, setIsNotificationVisible} = useNotification();        

    return useMutation({
      onError: (error: any) => {
        addNotification(`Υπήρξε κάποιο πρόβλημα στην διαγραφη του αρχείου.`, 500);
        console.error('Couldnt delete file', error);
        setIsNotificationVisible(true)
      },
      onSuccess: () => {           
      },
      ...config,
      mutationFn: bulkDeleteFile,
  })
}